import { useState, useLayoutEffect, useRef } from 'react';

const useDetectSticky = (ref, observerSettings = { threshold: [1] }) => {
  const [isSticky, setIsSticky] = useState(false);
  const newRef = useRef();
  ref ||= newRef;

  useLayoutEffect(() => {
    const cachedRef = ref.current,
      observer = new IntersectionObserver(([e]) => {
        setIsSticky(e.intersectionRatio < 1);
      }, observerSettings);

    observer.observe(cachedRef);

    return () => {
      observer.unobserve(cachedRef);
    };
  }, []);

  return [isSticky, ref, setIsSticky];
};

export { useDetectSticky };
